import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

const token = sessionStorage.getItem("ots_token");

// 🔹 ACCEPT LANDLORD
export const AcceptLandlord = createAsyncThunk(
  "landlord/accept",
  async (id, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/admin/update-landlord-status/${id}`,
        // {}, // no body
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 REJECT LANDLORD
export const RejectLandlord = createAsyncThunk(
  "landlord/reject",
  async (id, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/update-landlord-status/${id}`,
        { status: "rejected" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const LandlordActionsSlice = createSlice({
  name: "landlordActions",
  initialState: {
    loading: false,
    error: null,
    success: null,
  },

  extraReducers: (builder) => {
    builder
      // ACCEPT
      .addCase(AcceptLandlord.pending, (state) => {
        state.loading = true;
      })
      .addCase(AcceptLandlord.fulfilled, (state, action) => {
        state.loading = false;
        state.success = "Landlord Accepted Successfully!";
      })
      .addCase(AcceptLandlord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // REJECT
      .addCase(RejectLandlord.pending, (state) => {
        state.loading = true;
      })
      .addCase(RejectLandlord.fulfilled, (state, action) => {
        state.loading = false;
        state.success = "Landlord Rejected Successfully!";
      })
      .addCase(RejectLandlord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default LandlordActionsSlice.reducer;
